import apiProtected from '@lib/api/apiClient';
import { server } from '@lib/api/http';
import { useMutation } from '@tanstack/react-query';

export const useSupportMessageMutation = () => {
  return useMutation({
    mutationFn: (message: string) =>
      apiProtected.post(`${server}v1/dashboards/post-email-message-to-admins`, {
        message,
      }),
  });
};
